module.exports = __webpack_public_path__ + "img/all-member-amount-right-bottom-icon.6781ddb2.png";